import styled from 'styled-components'
import { BREAKPOINTS } from '~/shared/constants/uiConstants'

export const StyledContainer = {
  // Wrapper: styled.div`
  //   max-width: 375px;
  //   margin: 0 auto;
  //   padding: 0 16px;
  // `,

  Root: styled.div`
    max-width: ${BREAKPOINTS[375]}px;
    margin: 0 auto;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
  `,
}
